<template>
  <component :is="dashboardPerfil" />
</template>

<script>
import { mapGetters } from 'vuex'
import RhDashboardColaborador from './rh_dashboard_colaborador.vue'
import RhDashboardDiretoria from './rh_dashboard_diretoria.vue'
import RhDashboardLider from './rh_dashboard_lider.vue'

export default {
  name: 'RhDashboard',
  components: { RhDashboardColaborador, RhDashboardDiretoria, RhDashboardLider },
  computed: {
    ...mapGetters(['isInRole']),
    dashboardPerfil() {
      if (this.isInRole('rh-diretoria')) return 'RhDashboardDiretoria'
      if (this.isInRole('rh-lider')) return 'RhDashboardLider'
      return 'RhDashboardColaborador'
    },
  },
}
</script>
